import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BasicLabManagerItemModel} from "../../../models/lab-manager/basic-lab-manager-item";

@Component({
    selector: 'app-create-lab-submission',
    templateUrl: './create-lab-submission.component.html',
    styleUrls: ['./create-lab-submission.component.css'],
    standalone: false
})
export class CreateLabSubmissionComponent implements OnInit{

  selectedType: BasicLabManagerItemModel = null;
  submissionTypes: BasicLabManagerItemModel[] = [];

  constructor(
      private dialogRef: MatDialogRef<CreateLabSubmissionComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    this.submissionTypes = this.data.submissionTypes;
  }

  closeDialog(submissionType?: BasicLabManagerItemModel) {
    this.dialogRef.close(submissionType);
  }


}
